export default __webpack_public_path__ + "static/media/Celebration-dedication-right-bg.c9b1f1d8.png";